import styled from 'styled-components';

import {
  Button,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const SectionCaption = styled(Flex).attrs({
  row: true,
  justify: 'center',
  align: 'center',
})`
  height: 32px;
  width: 100%;
  color: #fff;
  background-color: #343a3d;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
`;

export const SectionContainer = styled(Flex).attrs({
  width: '100%',
  height: 'calc(100% - 32px)',
  justify: 'space-between',
  column: true,
})`
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
`;

export const SetPlan = styled(Button).attrs({
  type: 'button',
  appearance: 'success',
})`
  font-size: 16px;
  display: block;
  padding: 8px 25px;
  border-radius: 50px;
  transition: all 0.2s linear;

  ${props => props.isDisabled && `
    opacity: 0.55;
  `}
`;

export const PrimaryButton = styled(Button).attrs({
  type: 'button',
  appearance: 'primary',
})`
  font-size: 16px;
  display: block;
  padding: 8px 25px;
`;
